<template>

	
	<div :class="classes" :style="styles" v-if="theLogo !== ''">
		<img :src="theLogo" />
	</div>

</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'Logo',
	props: {
		logoOverride: {
			type: String,
			default: null
		}
	},
	computed: {

		...mapState('general',['logo','logoBG']),

		theLogo () {

			if ( this.logoOverride ) return this.logoOverride;

			return this.logo;

		},

		classes() {

			let c = {'logo':true};

			if ( this.logoBG !== '' ) {

				c.hasBG = true;

			}

			return c;

		},
		styles() {

			let s = [];

			if ( this.logoBG !== '' ) {

				s.push('background-color:'+this.logoBG);

			}

			return s.join('; ');

		}

	}

}
</script>
<style lang="less" scoped>

.logo {

	margin: 20px auto;
	width:300px;

	img {
		max-width: 100%;
	}

	&.desktop {

		width: 360px;

	}

}
</style>